import { backendUrl } from '../utils/AxiosConfiguration';
import type { TemplateStatEvent } from './contract';

/**
 * Meldet eine Kontakt-Betätigung an `POST /stats/event` (still tote Funktion,
 * jetzt wiederbelebt — siehe stats-event-report.md).
 *
 * Der Viewer-Pfad ist heiß (Auslieferungsbudget, siehe CLAUDE.md): die
 * Zählung darf den eigentlichen Klick (tel:/mailto:/wa.me/…) NIEMALS
 * verzögern oder verhindern. Deshalb fire-and-forget: `navigator.sendBeacon`
 * ist der Normalfall — er überlebt sogar einen sofortigen Seitenwechsel (z. B.
 * `window.open` mit `_self`) und blockiert nichts. Fällt `sendBeacon` weg
 * (fehlt oder lehnt ab), wird `fetch(..., { keepalive: true })` ohne
 * `await` abgeschickt. Jeder Fehler wird geschluckt — der Endpunkt antwortet
 * ohnehin immer 204, ein Zählfehler darf einen Klick nie sichtbar machen.
 */
export function reportStatEvent(urlKey: string, event: TemplateStatEvent): void {
  if (!urlKey) return;
  try {
    const url = `${backendUrl}/stats/event`;
    const body = JSON.stringify({ urlKey, event });

    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(url, blob)) return;
    }

    if (typeof fetch === 'function') {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {
        // Best effort — eine fehlgeschlagene Zählung darf den Klick nicht
        // sichtbar machen (der Endpunkt selbst antwortet ohnehin immer 204).
      });
    }
  } catch {
    // dito: niemals werfen, egal was schiefgeht (auch ein synchron
    // werfendes navigator.sendBeacon darf den Klick nicht verhindern).
  }
}
